import React, { useCallback, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router';
import uuid from 'react-uuid';
import { useDispatch } from 'react-redux';
import { addPageSpinner, removePageSpinner } from '../../Store/Actions/spinner';
import ApiService from "./../../Services/ApiService"
import { useState } from 'react';
import { ERROR_KEY } from '../../Constants/MainKeys';
import AlertService from '../../Services/AlertService';

export default function FAQ() {

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [faqData, setFaqData] = useState([])

  useEffect(() => {
    getFaqData();
  }, []);

  const getFaqData = () => {
    const spinnerId = uuid();
    setPageSpinner(spinnerId);
    ApiService.getFaqData().then(response => {
      if (response && response.data && response.data.data) {
        setFaqData(response.data.data)
      }
    }).catch(error => getFail(error)).finally(() => {
      extractPageSpinner(spinnerId)
    })
  }

  const scrollToCurrentPosition = (activeSection) => {
    const currentSection = document.getElementById(activeSection);

    if (currentSection) {
      window.scrollTo({
        top: currentSection.getBoundingClientRect().top + document.documentElement.scrollTop - 200,
        behavior: "smooth"
      });
      currentSection.classList.add("active-section");
      setTimeout(() => {
        currentSection.classList.remove("active-section");
      }, 5000);
    }
  };

  const setPageSpinner = useCallback(spinner => {
    dispatch(addPageSpinner(spinner));
  }, []);

  const extractPageSpinner = useCallback(spinner => {
    dispatch(removePageSpinner(spinner));
  }, []);

  const getFail = (error, spinnerId) => {
    error && AlertService.alert((AlertService.checkMessageType(error.respcode) || ERROR_KEY), error);
    spinnerId && extractPageSpinner(spinnerId);
  }

  return (
    <section className="cx--section mt-5">
      <div className="container">
        <div className='row'>
          <div className="cx--contact-info-wrapper">
            <strong className="cx--section-title-sm">FAQs</strong>
            <small className="d-block cx--contact-info-text mt-3">
              <span className='cursor-pointer text-underline' onClick={() => navigate("/")}>Home</span> / FAQs</small>
          </div>

          <div className="cx--contact-info-wrapper mt-2">
            <ol className='mt-3 ps-0'>
              {
                faqData && faqData.length ?
                  faqData.map(item => {
                    return <React.Fragment>
                      <li key={item.id} className='cursor-pointer ms-3' onClick={() => scrollToCurrentPosition(`block_${item.id}`)}><Link to="#">{item.question}</Link></li>
                    </React.Fragment>
                  })
                  : null
              }
            </ol>
          </div>
          {
            faqData && faqData.length ?
              faqData.map(item => {
                return <div key={item.id} id={`block_${item.id}`} className="cx--contact-info-wrapper mt-4">
                  <strong className="cx--section-title-lg">{item.question}</strong>
                  <div className="cx--contact-info-text mt-2">
                    <div dangerouslySetInnerHTML={{ __html: item.answer }}></div>
                  </div>
                </div>
              })
              : null
          }
        </div>
      </div>
    </section>
  )
}
